import { USER_REQUEST, USER_SUCCESS, USER_FAILURE } from 'app/actions/eljur/user';

const defaultState = {
  loading: false,
  result: {},
  error: '',
};

const user = (state = defaultState, action) => {
  switch (action.type) {

    case USER_REQUEST: {
      return { ...state, loading: true, error: '' };
    }

    case USER_SUCCESS: {
      return { ...state, ...action.payload, loading: false };
    }

    case USER_FAILURE: {
      return { ...state, loading: false, error: action.payload.err };
    }

    default:
  }
  return state;
};

export default user;
